module.exports = __webpack_public_path__ + "public/img/warn.e1edb8cf.png";